/**
 * Canvas / UI zoom steps.
 *
 * These were previously duplicated as two separate literals — `ZOOMLEVELS` in
 * `src/components/ZoomControlButton.tsx` (the on-screen +/- buttons) and
 * `ZOOM_LEVELS` in `src/player/GameController.tsx` (the Ctrl+= / Ctrl+-
 * shortcuts). Two copies of the same ladder is how the button and the keyboard
 * shortcut end up disagreeing about what "zoom in" means, so they now share
 * these.
 */
/**
 * Whiteboard canvas zoom, as whole percentages: 20% → 200% in steps of 10.
 *
 * Derived from integer percents rather than written as fractions so the ladder
 * is obviously complete and evenly spaced, and so the percentage readout in
 * `ZoomControlButton` cannot drift from the steps it is displaying.
 */
export var WHITEBOARD_ZOOM_PERCENTS = Array.from({ length: 19 }, function (_, i) { return 20 + i * 10; });
/** The same ladder as scale factors, which is what `zoomLevel` stores. */
export var WHITEBOARD_ZOOM_LEVELS = WHITEBOARD_ZOOM_PERCENTS.map(function (p) { return p / 100; });
/**
 * Icon / UI zoom (`playerIconZoom`) — deliberately NOT on the 10% ladder and
 * deliberately never below 1. It scales toolbar icons and the `--zoomed-*`
 * font-size custom properties, and the project's accessibility floor forbids an
 * effective font size below the 25px equivalent (see CLAUDE.md), which any
 * factor under 1 would breach.
 */
export var ICON_ZOOM_LEVELS = [1, 1.5, 2];
/**
 * The next step strictly greater than `current`, or `undefined` at the top.
 *
 * `current` is not necessarily one of the steps: zoom-to-fit sets an arbitrary
 * computed value (e.g. 0.36, and it keeps its own 5% floor, so it can sit below
 * the ladder's 20% minimum). Both callers therefore have to step relative to
 * the current value rather than look up an index.
 */
export var nextZoomLevel = function (levels, current) {
    return levels.find(function (l) { return l > current; });
};
/** The nearest step strictly less than `current`, or `undefined` at the bottom. */
export var prevZoomLevel = function (levels, current) {
    var prev;
    for (var _i = 0, levels_1 = levels; _i < levels_1.length; _i++) {
        var l = levels_1[_i];
        if (l < current)
            prev = l;
        else
            break;
    }
    return prev;
};
